import { System, SystemContext } from '../System';
import * as React from 'react';

export function useSystem(): System {
  return React.useContext(SystemContext);
}
